import { render, staticRenderFns } from "./PostLayer.vue?vue&type=template&id=247ad62c"
import script from "./PostLayer.vue?vue&type=script&lang=js"
export * from "./PostLayer.vue?vue&type=script&lang=js"
import style0 from "./PostLayer.vue?vue&type=style&index=0&id=247ad62c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports